<template>

    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->
    
      <h1>Solicitação de redefinição de senha</h1>
      <div style="text-align: right; width: 100%;">
            <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 200px;" @click="SolicitarNovaSenha();">
                <u>R</u>equisitar nova senha
            </button>
            <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 120px;" @click="Voltar();">
                <u>V</u>oltar
            </button>
        </div>
      <p><strong>Todos os campos abaixo são obrigatórios.</strong></p>

        <div class="col-12">
            <div class="alert alert-info mt-3">
                    <p>Para este recurso funcionar, você deve ter anteriormente configurado um e-mail no sistema para redefinição de senha no menu <strong>Usuários -> Alteração de dados pessoais</strong>.
    Este recurso não está habilitado para usuários internos do Tribunal de Justiça. Neste caso, contate o responsável pelo setor para geração de nova senha.
                    </p>
            </div>
        </div>



        <div class="container">
            <div class="row justify-content-left">
                <div class="col-md-5">
                    <div class="form-group mb-3">
                        <label for="cpf" style="width: 150px; text-align: right; margin-right: 5px; font-weight: bold;"><u>U</u>suário:</label>
                        <input type="text" id="usuario" class="form-personalizado" name="usuario" v-model="dados.usuario">
                    </div>

                    <div class="form-group mb-3">
                        <label for="cpf" style="width: 150px; text-align: right; margin-right: 5px; font-weight: bold;"><u>C</u>pf:</label>
                        <input type="text" class="form-personalizado" id="cpf" name="cpf" v-model="dados.cpf">
                    </div>

                    <div class="form-group mb-3">
                        <label for="dataNascimento" style="width: 150px; text-align: right; margin-right: 5px; font-weight: bold; vertical-align: middle;">Data de <u>N</u>ascimento:</label>
                        <input type="date"  class="form-personalizado" id="dataNascimento" name="dataNascimento" v-model="dados.data_nascimento">
                    </div>

                    <div class="form-group mb-3">
                        <label for="email" style="width: 150px; text-align: right; margin-right: 5px; font-weight: bold;">E<u>m</u>ail:</label>
                        <input type="email" class="form-personalizado" id="email" name="email" required v-model="dados.email">
                    </div>

                </div>
            </div>
        </div>

        <div style="text-align: right; width: 100%;">
            <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 200px;" @click="SolicitarNovaSenha();">
                <u>R</u>equisitar nova senha
            </button>
            <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 120px;" @click="Voltar();">
                <u>V</u>oltar
            </button>
        </div>



    </div>
  </template>
  
  <script>
    const baseUrl = window.Laravel.baseUrl;
  
    export default {
        data() {
            return {
                dados: {
                    usuario:'',
                    cpf:'',
                    data_nascimento:'',
                    email:'',
                },

            };
    },
    methods: {
            Voltar(){
                window.location.href = baseUrl + 'login';

            },
            SolicitarNovaSenha(){
                axios.post(baseUrl + 'forgot_pass', this.dados)
                    .then(response => {
                        alert(response.data.message);
                    })
                    .catch(error => {
                        alert(error.message);
                    });
            },
        },
    
  };
  </script>
  
  <style scoped>
.btn-primary {
    background-color: #007ebd;
}

/* Cor do botão no hover (escurecido) */
.btn-primary:hover {
    background-color: #005e94; /* Ajuste o valor percentual conforme necessário */
}

.btn-light{
    color: rgb(62, 136, 227); 
    border: solid 1px lightgray;
}

button u {
  text-decoration: underline;
}

.form-personalizado {
  display: inline;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

  </style>
  
